<template>
    <div>{{ $t('error.error_403') }}</div>
</template>
